import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PortfolioCaseItem } from '../../home.models';

@Component({
  selector: 'app-home-portfolio-section',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './portfolio-section.component.html'
})
export class PortfolioSectionComponent {
  @Input({ required: true }) portfolioCases: PortfolioCaseItem[] = [];
}
